<div class="card">

  <div class="card-header">
    {{'COMMON_PANEL_HEADING_ATTACHMENT' | translate}}
  </div>
  <div class="card-body">
    <app-material-attachment-gallery [loaderFactory]="fileLoaderFactory"
                                     [deleteAllowed]="rightModel.masterDataRecordAttachmentDelete.hasRight() && !readonly"
                                     [updateAllowed]="rightModel.masterDataRecordAttachmentUpdate.hasRight() && !readonly"
                                     [displayUpload]="rightModel.masterDataRecordAttachmentUpload.hasRight() && !readonly"
    #gallery>
    </app-material-attachment-gallery>
  </div>

</div><!-- /.card -->
